/**
 * Texts for Careers page
 */
export const careersPageText = {
    title: 'Kariera',
    titleMeta: 'Kariera — Oferty pracy | CamDiab',
    descriptionMeta: 'Poznaj możliwości kariery w CamDiab. Dołącz do zespołu poprawiającego życie z cukrzycą.',
    keywords: 'CamDiab kariera, praca, oferty, cukrzyca',
    localeMeta: 'pl_pl',

    bannerTitle: 'Oferty pracy',
    bannerSubtitle: 'Chcesz dołączyć do naszego zespołu?',
    heroNote: 'Wszystkie ogłoszenia publikowane są w języku angielskim.',

    introBody:
        'Szukasz nowych wyzwań i chcesz współtworzyć znaczące zmiany? Chętnie Cię poznamy. Inwestujemy w naszych ludzi — serce CamDiab. Świadczenia pracownicze mają wydobyć z każdego to, co najlepsze, w tym:',

    benefitsTitle: '',
    benefits: [
        'Hojny wkład pracodawcy w emeryturę',
        'Prywatne ubezpieczenie medyczne',
        'Ubezpieczenie na życie',
        'Roczna premia dyskrecjonalna',
        '29 dni urlopu plus 8 dni świąt ustawowych',
        'Możliwość pracy przy przełomowej technologii z potencjałem zmiany leczenia cukrzycy i poprawy wyników dla pacjentów',
        'Współpracujące i dynamiczne środowisko pracy',
        'Konkurencyjne wynagrodzenie i pakiet świadczeń, w tym rozwój zawodowy i awans',
    ],

    outroHtml:
        'Jeśli pasjonuje Cię realny wpływ na świat, chętnie Cię poznamy:<a href="mailto:hr@camdiab.com" class="careers-email-link">hr@camdiab.com</a>',

    vacancies: [],

    emptyVacancyTitle: 'Brak wolnych stanowisk',
    emptyVacancyBody:
        'Być może w tej chwili nie rekrutujemy, ale CamDiab rośnie i zawsze chętnie słuchamy osób pasjonujących się poprawą życia z cukrzycą. Wróć tu później.',

    applyLabel: 'Aplikuj teraz',
};
